import { jsx as _jsx } from "react/jsx-runtime";
import { useHistory } from 'react-router-dom';
import { useOverlayContext } from 'seagull';
import { GoogleMapsProvider, loadGoogleMaps } from '~/components/AddressAutocomplete';
import { useQboInVob } from '~/components/VendorOnboardingModal/useQboInVob';
import VendorOnboardingModal from '~/components/VendorOnboardingModal/VendorOnboardingModal';
import { routes } from '~/constants';
import { useIoContext } from '~/contexts';
import { useEventReporter } from '~/event-reporter';
import { useFeatureFlags } from '~/hooks/useFeatureFlags';
import { prevBusinessIdKey } from '~/hooks/useSwitchBusiness';
import { useStore, useStoreActions } from '~/store/store-context';
// Exported handler function that can be used directly when feature flag is enabled
export const handleCreateVendorAccountApprove = async (userInfo, api, logBI, reportToHeap, reportToHubspot)=>{
    logBI(18101);
    reportToHubspot('create_vendor_account_approve_v4');
    reportToHeap('top-bar', 'click', 'client-create-vendor-account-approve');
    if (!(userInfo === null || userInfo === void 0 ? void 0 : userInfo.hasApprovedTermsOfService())) {
        const userId = userInfo === null || userInfo === void 0 ? void 0 : userInfo.id();
        if (userId) {
            await api.auth.approveTos(userId);
        }
    }
};
export const useCreateVendorAccount = (onClick)=>{
    const userInfo = useStore((state)=>state.userInfo);
    const { SP_ONBOARDING_PHASE_1 } = useFeatureFlags();
    const { setWorksAt, api, logBI } = useStoreActions();
    const { reportToHeap, reportToHubspot } = useEventReporter();
    const overlayContext = useOverlayContext();
    const showQboStep = useQboInVob();
    const { localStorage } = useIoContext();
    const history = useHistory();
    const onCreateVendorAccount = async ()=>{
        onClick === null || onClick === void 0 ? void 0 : onClick();
        reportToHubspot('create_vendor_account_clicked_v2');
        reportToHeap('top-bar', 'click', 'client-create-vendor-account-topbar');
        await handleCreateVendorAccountApprove(userInfo, api, logBI, reportToHeap, reportToHubspot);
        const previousBusinessId = userInfo === null || userInfo === void 0 ? void 0 : userInfo.businessId();
        if (previousBusinessId) {
            localStorage.setItem(prevBusinessIdKey, previousBusinessId);
        }
        setWorksAt();
        if (SP_ONBOARDING_PHASE_1) {
            history.replace(routes.vendorOnboarding);
            return;
        }
        await overlayContext.showModal({
            content: (param)=>{
                let { dismissModal } = param;
                return /*#__PURE__*/ _jsx(GoogleMapsProvider, {
                    loadGoogleMaps: loadGoogleMaps,
                    children: /*#__PURE__*/ _jsx(VendorOnboardingModal, {
                        dismissModal: dismissModal,
                        showQboStep: !!showQboStep
                    })
                });
            },
            closeOnClickOutside: false,
            shouldBlurBackground: true,
            biName: 'vendor_onboarding_modal'
        });
    };
    return onCreateVendorAccount;
};
